import { useContext, useEffect } from 'react';
import { useChatContext } from 'stream-chat-react';
import ChatContext from './chatContext';

const useChatClient = () => {
    const initChat = useContext(ChatContext);
    const { client, ...rest } = useChatContext();

    useEffect(() => {
        if (!client) {
            initChat();
        }
    }, [initChat, client]);

    return { client, ...rest };
};

export default useChatClient;
